import React from 'react';
import { IconComponent } from 'edenred-ui';

import {
  ActionsSection,
  Body,
  CloseIcon,
  Container,
  Subtitle,
  Title,
  TitleSection,
  TitleWrapper
} from './ModalPanel.styles';

interface OwnProps {
  children: React.ReactNode;
  title: string | React.ReactElement;
  subtitle?: string | React.ReactElement;
  onClose?: () => void;
  primaryActionButton?: React.ReactElement;
  secondaryActionButton?: React.ReactElement;
  hideCloseIcon?: boolean;
  showTitleDivider?: boolean;
}

const ModalPanel = (props: OwnProps) => {
  const {
    children = null,
    title,
    subtitle,
    onClose = () => undefined,
    primaryActionButton = null,
    secondaryActionButton = null,
    hideCloseIcon = false,
    showTitleDivider = false
  } = props;

  return (
    <Container open={true}>
      <TitleSection>
        <TitleWrapper>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleWrapper>

        {!hideCloseIcon && (
          <CloseIcon
            onClick={() => {
              onClose();
            }}
          >
            <IconComponent iconType="close" />
          </CloseIcon>
        )}
      </TitleSection>
      {showTitleDivider && <hr />}
      {children && <Body>{children}</Body>}
      <ActionsSection>
        {secondaryActionButton}
        {primaryActionButton}
      </ActionsSection>
    </Container>
  );
};

export default ModalPanel;
